<div id="outprint" *ngIf="message">

    <div class = "row my-row mb-3 mt-xs-0 mb-xs-0">
        <!-- Objet du message -->
        <div class="col-8 my-col">
            <h1> {{ message.objet }} </h1>
        </div>
        <!-- Date d'envoi -->
        <div class="col-4 my-col pb-5">
            <span class="pt-3" style="float: right">
                {{ "OPEN.SEND-DATE" | translate }} <strong>{{ message.date_envoi }} </strong>
            </span>
            <span class="pt-3" style="float: right">
                {{ "OPEN.EXPIRE" | translate }} <strong>{{ message.expire }} </strong>
            </span>
        </div>
    </div>

    <div class = "row my-row justify-content-between">
        <div class="col-12 col-lg-10 my-col order-1">
            <table class="table-borderless">
                <thead>
                    <tr>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{{ "OPEN.SENDER" | translate }}</td>
                        <td>
                            <h4>
                                <span class="badge badge-primary">
                                    {{ message.sender }}
                                </span>
                            </h4>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ "OPEN.SIGNATORIES" | translate }}</td>
                        <td>
                            <h4 *ngIf="signatories">
                                <span *ngFor="let signatory of signatories" class="badge badge-primary mx-1">
                                    {{ signatory }}
                                </span>
                            </h4>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <div class="row row-cols-1 no-gutters my-row">
        <div class="col col-lg-11 bg-white border rounded mt-4 p-3 my-col">
            <div [innerHTML]="sanitizer.bypassSecurityTrustHtml(message.content)"></div>
        </div>
        <div class="col col-lg-11 pt-3 my-col" *ngIf="message.attachmentSize > 0">
            <!-- Pieces-jointes -->
            <h5>{{ "OPEN.ATTACHMENTS" | translate }}</h5>
            <div class="list-group">
                <a *ngFor="let attachment of message.attachments" (click)="downloadAttachment(attachment.filename)" id="{{attachment.filename}}" class="btn btn-link list-group-item list-group-item-action">
                    <em class="bi bi-file-earmark"></em>
                    {{ attachment.filename }}
                </a>
            </div>
            <button type="button" class="btn btn-primary mt-2" id="downloadAll" (click)="downloadAllAttachments()">
                {{ "BUTTONS.DOWNLOAD-ALL" | translate }}
            </button>
        </div>
    </div>

    <div *ngIf="!userService.currentUser.openMessage" class="row row-cols-1 my-row pt-5 pb-5 justify-content-start print-none">
        <div class="col-lg-11 my-col">
            <h5>{{ "OPEN.EVENTS" | translate }}</h5>
            <ul class="list-group">
                <li class="list-group-item" *ngFor="let e of this.message.events">
                    {{e}}
                </li>
            </ul>
        </div>
    </div>

    <div *ngIf="userService.currentUser.openMessage" class="row row-cols-1 my-row pt-5 pb-5 justify-content-start print-none">
        <div class="col-lg-11 my-col">
            <div class="alert alert-info" role="alert">
                {{ "OPEN.INFO-PATIENT" | translate }} <strong>{{ message.expire }}</strong>
            </div>
        </div>
    </div>
    
    <div class="col-lg-11 my-col">
        <button type="button" (click)="openRespondModal()" class="btn btn-primary">
            <i class="bi bi-reply"></i>
            {{ "BUTTONS.RESPOND" | translate }}
        </button>
    </div>
    <!--<app-spinner-loader *ngIf="loading$ | async"></app-spinner-loader>-->
</div>